(function () {
    'use strict';

    angular.module('swif.interventions')
    .directive('listGroupItemTask', listGroupItemTask)
    .directive('costOfTasks', costOfTasks)
    .directive('referentielItemTableTask', referentielItemTableTask)
    .directive('panelTask', panelTask)
    .directive('tableTasks', tableTasks)
    .directive('narrowTableTasks', narrowTableTasks)
    .directive('taskAssignedTo', taskAssignedTo)
    .directive('taskSpentTime', taskSpentTime)

    .component('openstcRecurrentTaskChoice', {
        templateUrl: 'partials/openstc/openstc_recurrent_task_choice.html',
        controller: OpenstcRecurrentTaskChoiceController,
        bindings: {
            recurrenceChoice: '='
        }
    })
    .component('openstcTasksToDuplicateTable', {
        templateUrl: 'partials/openstc/openstc_tasks_to_duplicate_table.html',
        controller: OpenstcTasksToDuplicateController,
        bindings: {
            tasksToDuplicate: '='
        }
    });

    function OpenstcRecurrentTaskChoiceController() {
        if (!this.recurrenceChoice){
            // onlyThisTask is the default choice
            this.recurrenceChoice = 'onlyThisTask';
        }
    }

    function OpenstcTasksToDuplicateController() {
        this.deleteTaskToDuplicate = function (task) {
            _.remove(this.tasksToDuplicate.items, task);
        };
    }

    function listGroupItemTask () {
        return {
            restrict: 'A',
            replace: true,
            scope: {
                listGroupItemTask: '='
            },
            templateUrl: 'partials/openstc/list-group-item-task.html'
        };
    }

    costOfTasks.$inject = ['$q', '$location', 'swifInterventionsService', 'dataService'];
    function costOfTasks ($q, $location, moduleInter, swifData) {
        return {
            restrict: 'A',
            replace: true,
            require: 'ngModel',
            scope: {},
            link: function (scope, element, attr, ngModel) {
                scope.debug = $location.search().debug;
                var uniq = function (items) {
                    return _.uniq(items, function (item) { return item[0]; });
                };
                ngModel.$render = function () {
                    var vv = ngModel.$viewValue;
                    if (!_.isArray(vv) && !_.isUndefined(vv)) {
                        scope.proxy = [vv];
                    } else {
                        scope.proxy = vv;
                    }
                };
                scope.displayEquipmentDetails = false;
                scope.toggleDisplayEquipmentDetails = function () {
                    scope.displayEquipmentDetails = !scope.displayEquipmentDetails;
                };
                scope.displayRHDetails = false;
                scope.toggleDisplayRHDetails = function () {
                    scope.displayRHDetails = !scope.displayRHDetails;
                };
                scope.displaySuppliersDetails = false;
                scope.toggleDisplaySuppliersDetails = function () {
                    scope.displaySuppliersDetails = !scope.displaySuppliersDetails;
                };
                scope.displayConsumableDetails = false;
                scope.toggleDisplayConsumableDetails = function () {
                    scope.displayConsumableDetails = !scope.displayConsumableDetails;
                };
                scope._parseCosts = function () {
                    var total = 0;
                    var contract = {cost: 0, lines: [], details: []};
                    var actors = {
                        rh: {cost: 0, lines: [], details: []},
                        suppliers: {cost: 0, lines: [], details: []}
                    };
                    var consumables = {cost: 0, lines: [], details: []};
                    var equipments = {cost: 0, lines: [], details: []};

                    // first, check if ngModel contains contract/inter having project_cost
                    _.forEach(scope.proxy, function (proxyItem) {
                        if (proxyItem.project_cost) {
                            contract.cost += proxyItem.project_cost;
                            contract.lines.push(proxyItem);
                            contract.lines = uniq(contract.lines);
                        }
                    });

                    // loop for tasks to compute total costs, rh, consu and equipments subtotals
                    _.forEach(scope.tasks, function (task) {
                        total += task.cost || 0.0;
                        // scope.rh.cost += task.hr_cost || 0.0; -> done below
                        consumables.cost += task.consumable_cost || 0.0;
                        equipments.cost += task.equipment_cost || 0.0;

                        // also, add equipments to the equipment-lines infos
                        // this data is different from equipment_lines (vehicle consumption)
                        _.forEach(task.equipment_names, function (equipment) {
                            equipments.lines.push(equipment);
                        });
                        equipments.lines = uniq(equipments.lines);
                    });
                    // fetch all works, equipments and consumables from task(s)
                    // then, parse them to group data using uniq()
                    $q.all([
                        moduleInter.task.getWorks(scope.tasks),
                        moduleInter.task.getEquipmentLines(scope.tasks),
                        moduleInter.task.getConsumedFromTasks(scope.tasks)]
                    ).then(function (data) {
                        var works = data[0];
                        var elines = data[1];
                        var consumableLines = data[2];
                        // first, parse RH data
                        _.forEach(works, function (work) {
                            var actor, actorType;
                            if (!_.isEmpty(work.partner_id)) {
                                actor = work.partner_id;
                                actorType = 'suppliers';
                            } else if (!_.isEmpty(work.user_id)) {
                                actor = work.user_id;
                                actorType = 'rh';
                            }
                            actors[actorType].lines.push(actor);
                            actors[actorType].lines = uniq(actors[actorType].lines);
                            //add to the right actor work.cost & work.hours
                            for (let agentLine of actors[actorType].lines){
                                if(agentLine[0]===work.user_id[0]){
                                    if (_.isUndefined(agentLine[2])){agentLine[2]=0;}
                                    if (_.isUndefined(agentLine[3])){agentLine[3]=0;}
                                    agentLine[2] += work.hours;
                                    agentLine[3] += work.cost;
                                }
                            }
                            actors[actorType].details.push(work);
                            actors[actorType].cost += work.cost || 0.0;
                        });

                        /* CHECK: unplug this because agents can t see equipment lines*/
                        _.forEach(elines, function (eq_line) {
                            if(eq_line.equipment_id) {
                                // add vehicle to the equipment lines
                                equipments.lines.push(eq_line.equipment_id);
                            }
                            equipments.details.push(eq_line);
                        });

                        equipments.lines = uniq(equipments.lines);

                        _.forEach(consumableLines, function (cons) {
                            if(cons.consumable_id) {
                                consumables.lines.push(cons.consumable_id);
                            }
                            consumables.details.push(cons);
                        });

                        consumables.lines = uniq(consumables.lines);
                    });

                    scope.total = total;
                    scope.contract = contract;
                    scope.rh = actors.rh;
                    scope.suppliers = actors.suppliers;
                    scope.consumables = consumables;
                    scope.equipments = equipments;
                };

                scope.$watch('proxy', function (newV) {
                    var vv = newV;
                    if (_.isEmpty(vv)) {
                        return;
                    }
                    // 2 cases: we pass task(s), or we passe intervention
                    // for intervention, retrieve only its tasks with works
                    var inter_ids = [];
                    var tasks = [];
                    // loop on ngModel to check if there is inter(s) and / or task(s)
                    _.forEach(vv, function (item) {
                        if(item._type === 'intervention' || item._type === 'contract') {
                            inter_ids.push(item.id);
                        } else {
                            tasks.push(item);
                        }
                    });
                    // if there is intervention(s), fetch their tasks,
                    // and merge them to the tasks optionaly found on ngModel
                    if(inter_ids.length > 0) {
                        var fields = [
                            'cost',
                            'hr_cost',
                            'equipment_cost',
                            'consumable_cost',
                            'equipment_names'
                        ];
                        var filter = {fields: fields};
                        swifData.addFilter(filter, 'project_id', 'in', inter_ids);
                        swifData.addFilter(filter, 'work_ids', '!=', false);
                        swifData.get('task', undefined, filter)
                        .then(function (data) {
                            scope.tasks = data;
                            if(tasks) {
                                scope.tasks.concat(tasks);
                            }
                            scope._parseCosts();
                        });
                    }
                    // else, means there is only tasks on to ngModel
                    else {
                        scope.tasks = tasks;
                        scope._parseCosts();
                    }
                }, true);
            },
            templateUrl: 'partials/openstc/cost-of-tasks.html'
        };
    }

    referentielItemTableTask.$inject = ['swifFrameworkService'];
    function referentielItemTableTask(swif) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                collection: '=',
                states: '=',
                itemType: '@',
                title: '@',
                refresh: '&refreshCallback'
            },
            templateUrl: 'partials/openstc/task_referentiel_item_table_directive.html',
            link: function (scope, element, attr, ngModel) {
                scope.getRange = function(max) {
                    return new Array(max);
                };
                scope.canEdit = function(item) {
                    return item.active && item.actions.indexOf("update") > -1;
                };
                scope.callback = function(error, data) {
                    if (data.action.id === 'replace') {
                        var action = swif.action.getActionById('patrimoine_equipment', 'misc', 'replace', data);
                        if (action) {
                            var newEquipmentData = {
                                "categ_id": data.model.categ_id,
                                "name": data.model.name,
                                "qty_available": data.model.qty_available,
                                "description": data.model.description,
                                "parent_id": data.model.parent_id,
                                "site_id": data.model.site_id,
                                "date_start": data.model.date_start,
                                "life_duration": data.model.life_duration,
                                "state": 'new',
                                "_osm_zoom": 0
                            };

                            swif.data.callKw(
                                'equipment',
                                'deactivate_unlink',
                                [data.model.id]
                            ).then(function() {

                                var options = {
                                    callback: (error, data) => {
                                        scope.refresh();
                                        swif.message.addInfo('The equipment has been replaced successfully');
                                    }
                                };
                                swif.action.dispatch('patrimoine_equipment', action, newEquipmentData, options);
                            });
                        }
                    } else {
                        scope.collection.callback(error, data);
                    }
                }
            }
        };
    }

    panelTask.$inject = ['swifFrameworkService', 'swifPanelService', 'swifOpenbaseSiteService'];
    function panelTask (swif, panel, siteService) {
        var params = {
            fields: [
                'id',
                'swif_id',
                'ask_id',
                'name',
                'state',
                'site1',
                'category_id',
                'service_id',
                'user_id',
                'team_id',
                'partner_id',
                'partner_address',
                'notify',
                'project_id',
                'date_start',
                'date_end',
                'recurrence_id',
                'planned_hours',
                'effective_hours',
                'equipment_id',
                'description'
            ]
        };
        var linked = function(scope, element, attr, ngModel) {
            // Display complete site address if patrimoine module is installed
            var _task = ngModel.$viewValue;
            if (swif.settings.app.modules.openstc_patrimoine && _task.site1) {
                siteService.getSiteAddressById(_task.site1[0]).then(site => {
                    siteService.getSiteAddressFields().map(field => {
                        scope.item[field] = site[field];
                    });
                });
            }
        }
        var directive = panel.create_directive('task', params, linked);
        directive.templateUrl = 'partials/openstc/panel-task.html';
        return directive;
    }

    function narrowTableTasks () {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: 'partials/openstc/tasks_narrow_table_directive.html'
        };
    }

    function tableTasks () {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: 'partials/openstc/tasks_table_directive.html'
        };
    }

    taskAssignedTo.$inject = ['swifPanelService'];
    function taskAssignedTo (panel) {
        var directive = panel.create_directive('task', undefined);
        delete directive.transclude;
        directive.templateUrl = 'partials/openstc/task_assigned_to.html';
        return directive;
    }

    taskSpentTime.$inject = ['swifPanelService'];
    function taskSpentTime (panel) {
        var directive = panel.create_directive('task', undefined);
        delete directive.transclude;
        directive.templateUrl = 'partials/openstc/task_spent_time.html';
        return directive;
    }

})();
